import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { FeatureFlagsPane } from 'owa-header-pane';
import { observer } from 'mobx-react';
var FeatureFlagsCharm = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsCharm, _super);
    function FeatureFlagsCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm, { title: "Feature Flags", key: "featureflags", icons: { iconName: "Flag" /* Flag */ }, ariaLabel: "featureflags charm" // No need to localize as it is a DEV feature only
            , behavior: {
                paneComponent: FeatureFlagsPane,
                charm: 1 /* FeatureFlagsCharm */,
            } }));
    };
    FeatureFlagsCharm = tslib_1.__decorate([
        observer
    ], FeatureFlagsCharm);
    return FeatureFlagsCharm;
}(React.Component));
export default FeatureFlagsCharm;
//# sourceMappingURL=FeatureFlagsCharm.js.map